import React, { useState } from 'react';
import { FadeIn } from '../ui/FadeIn';
import { Timer, Trophy, BookOpen, Star, TrendingUp, Flame, Lock, Zap, Shield, CreditCard } from 'lucide-react';
import { OfferCountdown } from '../ui/OfferCountdown';
export function Offer() {
  const [selectedPlan, setSelectedPlan] = useState<'basic' | 'complete'>('complete');
  return <section id="oferta" className="py-24 bg-navy-light scroll-mt-10 relative overflow-hidden" data-id="element-148">
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[600px] h-[400px] bg-gold/10 rounded-full blur-3xl pointer-events-none" data-id="element-149"></div>
      <div className="absolute bottom-10 left-0 w-72 h-72 bg-magenta/10 rounded-full blur-3xl pointer-events-none" data-id="element-150"></div>
      <div className="absolute top-1/2 right-0 w-72 h-72 bg-cyan/10 rounded-full blur-3xl pointer-events-none" data-id="element-151"></div>

      <div className="container mx-auto px-4 max-w-3xl relative z-10" data-id="element-152">
        {/* Urgency block */}
        <FadeIn data-id="element-153">
          <div className="mb-8 text-center" data-id="element-154">
            <div className="inline-flex items-center gap-2 bg-red-500/15 border border-red-500/40 text-red-300 px-4 py-1.5 rounded-full text-xs md:text-sm font-bold uppercase tracking-wider mb-5" data-id="element-155">
              <Flame className="w-4 h-4" data-id="element-156" />
              La oferta cierra en
            </div>
            <OfferCountdown data-id="element-157" />
            <p className="text-beige/90 text-base md:text-lg font-semibold mt-5 max-w-xl mx-auto" data-id="element-158">
              Después sube <span className="text-red-400" data-id="element-159">$8.000 ARS</span> y{' '}
              <span className="underline decoration-red-400/50" data-id="element-160">
                no vuelve a bajar
              </span>
              .
            </p>

            {/* Cupos progress */}
            <div className="max-w-md mx-auto mt-6 bg-navy border border-gold/20 rounded-2xl p-4" data-id="element-161">
              <div className="flex items-center justify-between mb-2 text-sm" data-id="element-162">
                <span className="text-beige/80 flex items-center gap-1.5" data-id="element-163">
                  <TrendingUp className="w-4 h-4 text-gold" data-id="element-164" />
                  Cupos al precio de lanzamiento
                </span>
                <span className="text-gold font-bold" data-id="element-165">68% tomados</span>
              </div>
              <div className="w-full h-2.5 bg-navy-lighter rounded-full overflow-hidden" data-id="element-166">
                <div className="h-full bg-gradient-to-r from-gold to-gold-light rounded-full transition-all duration-1000" style={{
                width: '68%'
              }} data-id="element-167"></div>
              </div>
            </div>
          </div>
        </FadeIn>

        <FadeIn delay={0.1} data-id="element-168">
          <div className="bg-navy border border-gold/20 rounded-3xl p-6 md:p-10 relative shadow-2xl" data-id="element-169">
            {/* Title */}
            <h2 className="text-2xl md:text-4xl font-black text-beige text-center mb-2" data-id="element-170">
              Elegí tu{' '}
              <span className="text-gold drop-shadow-glow-gold" data-id="element-171">
                MUSIC PRO KIT
              </span>
            </h2>
            <p className="text-center text-beige/60 mb-8 text-sm md:text-base" data-id="element-172">
              Ambas opciones incluyen los 7 bonos exclusivos
            </p>

            {/* Plan options */}
            <div className="space-y-4 mb-6" data-id="element-173">
              {/* Basic Plan */}
              <button type="button" onClick={() => setSelectedPlan('basic')} className={`w-full text-left bg-navy-lighter border rounded-2xl p-5 transition-all ${selectedPlan === 'basic' ? 'border-gold/60 shadow-[0_0_20px_rgba(255,200,61,0.2)]' : 'border-beige/10 hover:border-beige/20'}`} data-id="element-174">
                <div className="flex items-start gap-4" data-id="element-175">
                  <div className={`mt-1 w-5 h-5 rounded-full border-2 flex items-center justify-center flex-shrink-0 ${selectedPlan === 'basic' ? 'border-gold' : 'border-beige/30'}`} data-id="element-176">
                    {selectedPlan === 'basic' && <div className="w-2.5 h-2.5 rounded-full bg-gold" data-id="element-177"></div>}
                  </div>
                  <div className="flex-1 flex flex-wrap items-center justify-between gap-3" data-id="element-178">
                    <div data-id="element-179">
                      <div className="flex items-center gap-2 mb-1" data-id="element-180">
                        <BookOpen className="w-4 h-4 text-cyan" data-id="element-181" />
                        <h3 className="font-black text-beige text-base md:text-lg tracking-wide" data-id="element-182">
                          MUSIC PRO KIT
                        </h3>
                      </div>
                      <p className="text-sm text-beige/60" data-id="element-183">
                        6 tomos + 7 bonos exclusivos
                      </p>
                    </div>
                    <div className="text-right" data-id="element-184">
                      <p className="text-sm text-beige/40 line-through" data-id="element-185">
                        $34.990
                      </p>
                      <p className="text-2xl md:text-3xl font-black text-beige" data-id="element-186">
                        $19.990
                      </p>
                    </div>
                  </div>
                </div>
              </button>

              {/* Complete Pack (Recommended) */}
              <button type="button" onClick={() => setSelectedPlan('complete')} className={`w-full text-left bg-navy-lighter border-2 rounded-2xl p-5 transition-all relative ${selectedPlan === 'complete' ? 'border-gold shadow-[0_0_30px_rgba(255,200,61,0.4)]' : 'border-gold/40 hover:border-gold/60'}`} data-id="element-187">
                <div className="flex items-start gap-4" data-id="element-188">
                  <div className={`mt-1 w-5 h-5 rounded-full border-2 flex items-center justify-center flex-shrink-0 ${selectedPlan === 'complete' ? 'border-gold' : 'border-beige/30'}`} data-id="element-189">
                    {selectedPlan === 'complete' && <div className="w-2.5 h-2.5 rounded-full bg-gold drop-shadow-glow-gold" data-id="element-190"></div>}
                  </div>
                  <div className="flex-1" data-id="element-191">
                    <div className="flex flex-wrap items-center justify-between gap-3 mb-2" data-id="element-192">
                      <div className="flex items-center gap-2" data-id="element-193">
                        <Trophy className="w-5 h-5 text-gold drop-shadow-glow-gold" data-id="element-194" />
                        <h3 className="font-black text-beige text-base md:text-lg tracking-wide" data-id="element-195">
                          PACK COMPLETO
                        </h3>
                      </div>
                      <div className="text-right" data-id="element-196">
                        <p className="text-sm text-beige/40 line-through" data-id="element-197">
                          $43.990
                        </p>
                        <p className="text-2xl md:text-3xl font-black text-gold drop-shadow-glow-gold" data-id="element-198">
                          $27.990
                        </p>
                      </div>
                    </div>

                    <div className="flex flex-wrap gap-2 mb-2" data-id="element-199">
                      <span className="inline-flex items-center gap-1 bg-gold text-navy text-[10px] md:text-xs font-black px-2.5 py-1 rounded-md uppercase tracking-wider" data-id="element-200">
                        <Star className="w-3 h-3 fill-navy" data-id="element-201" />
                        Más elegido
                      </span>
                      <span className="inline-flex items-center bg-lime/20 border border-lime/40 text-lime text-[10px] md:text-xs font-black px-2.5 py-1 rounded-md uppercase tracking-wider" data-id="element-202">
                        Ahorrás $16.000
                      </span>
                    </div>
                    <p className="text-sm text-beige/70" data-id="element-203">
                      6 tomos + 7 bonos +{' '}
                      <span className="text-gold font-bold" data-id="element-204">PRO Élite™</span>
                    </p>
                  </div>
                </div>
              </button>
            </div>

            {/* CTA - dynamic checkout link based on selected plan */}
            <a href={selectedPlan === 'complete' ? 'https://checkout.tusbeneficios.shop/cart/51120040149225:1' : 'https://checkout.tusbeneficios.shop/cart/50965915992297:1'} target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center w-full bg-gold hover:bg-gold-hover text-navy font-black text-base md:text-xl py-5 px-6 rounded-2xl transition-all duration-300 transform hover:scale-[1.02] hover:shadow-[0_10px_40px_rgba(255,200,61,0.4)] mb-4 uppercase tracking-wide shadow-[0_8px_30px_rgba(255,200,61,0.25)]" data-id="element-205">
              <span className="flex items-center gap-2" data-id="element-206">
                SÍ, QUIERO{' '}
                {selectedPlan === 'complete' ? 'PACK COMPLETO' : 'MUSIC PRO KIT'}
                <span aria-hidden data-id="element-207">→</span>
              </span>
            </a>

            <p className="text-center text-sm text-beige/50 italic mb-6" data-id="element-208">
              {selectedPlan === 'complete' ? 'La opción más elegida por alumnos que buscan el máximo nivel' : 'Empezá tu camino musical hoy mismo'}
            </p>

            {/* Trust badges at bottom */}
            <div className="border-t border-beige/10 pt-5" data-id="element-209">
              <div className="flex flex-wrap items-center justify-center gap-x-5 gap-y-3 text-xs md:text-sm text-beige/70" data-id="element-210">
                <div className="flex items-center gap-1.5" data-id="element-211">
                  <Lock className="w-4 h-4 text-magenta-light" data-id="element-212" />
                  <span data-id="element-213">Pago seguro</span>
                </div>
                <div className="flex items-center gap-1.5" data-id="element-214">
                  <Zap className="w-4 h-4 text-cyan" data-id="element-215" />
                  <span data-id="element-216">Acceso en 5 min</span>
                </div>
                <div className="flex items-center gap-1.5" data-id="element-217">
                  <Shield className="w-4 h-4 text-gold" data-id="element-218" />
                  <span data-id="element-219">Garantía 7 días</span>
                </div>
                <div className="flex items-center gap-1.5" data-id="element-220">
                  <CreditCard className="w-4 h-4 text-lime" data-id="element-221" />
                  <span data-id="element-222">Astropay</span>
                </div>
              </div>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}